import i18n from "@/i18n/config";

let pending: Promise<void> | null = null;

/**
 * Lazily fetches and registers the Document Intelligence feature's
 * translation keys ("documentScanner") into the default i18next namespace.
 * Kept out of the eager i18n/config.ts bundle so this copy, across 6
 * languages, does not ship in the main entry chunk for visitors who never
 * open the Documents page. Idempotent and cached.
 */
export function ensureDocumentScannerLocaleLoaded(): Promise<void> {
  if (!pending) {
    pending = Promise.all([
      import("./locales/document-scanner/en.json"),
      import("./locales/document-scanner/es.json"),
      import("./locales/document-scanner/fr.json"),
      import("./locales/document-scanner/hi.json"),
      import("./locales/document-scanner/pa.json"),
      import("./locales/document-scanner/ur.json"),
    ]).then(([en, es, fr, hi, pa, ur]) => {
      i18n.addResourceBundle("en", "translation", en.default, true, true);
      i18n.addResourceBundle("es", "translation", es.default, true, true);
      i18n.addResourceBundle("fr", "translation", fr.default, true, true);
      i18n.addResourceBundle("hi", "translation", hi.default, true, true);
      i18n.addResourceBundle("pa", "translation", pa.default, true, true);
      i18n.addResourceBundle("ur", "translation", ur.default, true, true);
    });
  }
  return pending;
}
